// /js/state/store.js
export const store = {
  URL_PHP: "https://cozumel-reef-maps.com.mx/",
  currentLoginUserId: null,
  IMG_FOLDER: "https://cozumel-reef-maps.com.mx/Views/Default/img/",

  GLOBAL_EMAIL: "",
  GLOBAL_NAME: "",
  GLOBAL_PASSWROD: "",

  SELECTED_PLAN: null,
  SELECTED_PRICE: 0,

  // si lo usas (no lo vi definido en módulos)
  refStorage: null,

  session: {
    user: {
      id: window.APP_SESSION?.user?.id || null,
      email: window.APP_SESSION?.user?.email || null,
      user_nombre: window.APP_SESSION?.user?.user_nombre || null,
      user_type: window.APP_SESSION?.user?.user_type || null,
      key_user: window.APP_SESSION?.user?.key_user || null,
      comision: window.APP_SESSION?.user?.comision || null
    },
    logged: !!window.APP_SESSION?.user?.id
  }

};







